import { render } from "react-dom";
import MapPopup from "../Common/MapPopup/MapPopup";
import React from "react";
export const renderLegacyPopup = (mapPopupRows) => {
    const element = document.createElement("div");
    render(React.createElement(MapPopup, { mapPopupRows: mapPopupRows, handleSelect: () => { }, handleUnselect: () => { } }), element);
    return element;
};
